@if (visibleKeynote(); as keynote) {
  <div
    class="transformation-arrow-keynote"
    [class.transformation-arrow-keynote--personality]="side() === 'personality'"
    [class.transformation-arrow-keynote--design]="side() === 'design'"
    data-test-id="transformation-arrow-keynote"
    aria-hidden="true"
    [style.border-color]="fillColor()"
  >
    {{ keynote.name }}
  </div>
}

<svg
  class="transformation-arrow"
  [class.points-right]="pointsRight()"
  viewBox="0 0 26 24"
  preserveAspectRatio="xMidYMid meet"
  aria-hidden="true"
  focusable="false"
>
  @if (pointsRight()) {
    <!-- shaft overlapt 2px met de driehoek om een haarlijn te vermijden;
         driehoek-back is ingekort (y 4 → 20) en punt ligt op x=26 zodat de pijl
         compacter is en gelijkmatig in het vierkante kader past. -->
    <rect x="4" y="8" width="10" height="8" [attr.fill]="fillColor()" />
    <polygon points="12,4 12,20 26,12" [attr.fill]="fillColor()" />
  } @else {
    <polygon points="0,12 14,4 14,20" [attr.fill]="fillColor()" />
    <rect x="12" y="8" width="10" height="8" [attr.fill]="fillColor()" />
  }
</svg>
